import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';

const template = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 18px;
    background-color: ${`${theme?.colour?.primary}0D`};
  `}
`;

export default Wrapper(template);